import React, { useState, useEffect } from 'react'
import {
    Modal,
    Input,
    Select
} from 'antd'
import { CirclePicker } from 'react-color'
import RowLayout from './../../RowLayout/RowLayout'

const { Option } = Select

const COLORS = {
    red: '#e74c3c',
    blue: '#3498db',
    green: '#1abc9c',
    orange: '#e67e22',
    yellow: '#f1c40f'
}

const COLOR_NAMES = ['red', 'blue', 'green', 'orange', 'yellow']

const TAG_ANIMATIONS = [
    'none',
    'bounce',
    'flash',
    'pulse',
    'rubberBand',
    'shake',
    'swing',
    'tada',
    'wobble',
    'jello',
    'heartBeat'
]

const TagEditorModal = ({
    T,
    isOpen,
    text,
    color,
    animation,
    onSubmit,
    onClose
}) => {
    let [currentText, setCurrentText] = useState('')
    let [currentColor, setCurrentColor] = useState('')
    let [currentAnimation, setCurrentAnimation] = useState('')

    useEffect(() => {
        if (isOpen) {
            setCurrentText(text)
            setCurrentColor(color || 'red')
            setCurrentAnimation(animation)
        } else {
            setCurrentText('')
            setCurrentColor('')
            setCurrentAnimation('none')
        }
    }, [isOpen])

    function onChangeColor(colorCode) {
        for (const [key, value] of Object.entries(COLORS)) {
            if (colorCode == value) {
                setCurrentColor(key)
                break
            }
        }
    }

    function onOk() {
        onSubmit({
            text: currentText,
            color: currentColor,
            animation: currentAnimation
        })
    }

    return (
        <Modal
            title={T('TAG')}
            centered
            destroyOnClose
            visible={isOpen}
            okText={T('OK')}
            cancelText={T('CANCEL')}
            onOk={() => onOk()}
            onCancel={() => onClose()}>
            <RowLayout title={T('TAG_TEXT')} contentSpan={14}>
                <div style={{ marginBottom: 24 }}>
                    <Input
                        value={currentText}
                        onChange={e => setCurrentText(e.target.value)}
                    />
                </div>
            </RowLayout>

            <RowLayout title={T('TAG_COLOR')} contentSpan={14}>
                <div style={{ marginBottom: 24 }}>
                    <CirclePicker
                        width={400}
                        color={COLORS[currentColor]}
                        colors={COLOR_NAMES.map(color => COLORS[color])}
                        onChange={color => onChangeColor(color.hex)}
                    />
                    {/* <ColorPicker
                        T={T}
                        isOpen={isOpenTagColorPicker}
                        color={currentColor}
                        onToggle={setIsOpenTagColorPicker.bind(this)}
                        onChange={color => setCurrentColor(color.hex)}
                    /> */}
                </div>
            </RowLayout>

            <RowLayout title={T('TAG_ANIMATION')} contentSpan={14}>
                <div style={{ marginBottom: 24 }}>
                    <Select
                        value={currentAnimation}
                        style={{ width: 120 }}
                        onChange={setCurrentAnimation.bind(this)}>
                        {TAG_ANIMATIONS.map(item => (
                            <Option key={item} value={item}>
                                {item}
                            </Option>
                        ))}
                    </Select>
                </div>
            </RowLayout>

            <RowLayout title={T('PREVIEW')} contentSpan={14}>
                {currentText && (
                    <div
                        style={{
                            display: 'inline-block',
                            marginRight: 12
                        }}>
                        <div
                            className={`menutypetag menutypetag--${currentColor} animated infinite ${currentAnimation}`}>
                            {currentText}
                        </div>
                    </div>
                )}
            </RowLayout>
        </Modal>
    )
}

export default TagEditorModal
